import styled from 'styled-components';

export const IdleRecommendationHeaderTitleBox = styled.div`
    // from cgp-theme-property-color-main
    color: ${({theme}) => theme.colors.brandPrimary};
`;
